"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _common = require("@insided/shared/utils/common");

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var _classnames = _interopRequireDefault(require("classnames"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var checkIfImageResizedAlready = /attachment\/(width|height)\//;
/**
 * Fallback viewport height used when we can't measure the real one (e.g.
 * during SSR, where `window` is unavailable).
 *
 * Why this exists: we ask the CDN for a height-resized variant of an image
 * to avoid shipping the full upload. The ideal height would be the user's
 * actual inner-viewport height, but the server doesn't know it, so we fall
 * back to this constant. `911` was picked because it's the most common
 * inner-viewport height observed in NewRelic RUM data for our destination
 * traffic.
 *
 * Caveat: any time the real viewport differs from this default, the SSR'd
 * `<img>` is sized for the wrong intrinsic dimensions and the browser will
 * reflow once the image loads, contributing to CLS. Passing a viewport-height
 * hint from the server (e.g. via `Sec-CH-Viewport-Height` or a `User-Agent`
 * sniff) is a planned follow-up that would let us emit accurate dimensions
 * and remove this CLS source entirely.
 *
 * Superseded by `srcset`/`sizes` once PR 2 of the LazyImage modernization
 * lands.
 */

var FALLBACK_VIEWPORT_HEIGHT = 911;

var getDefaultResizeHeight = function getDefaultResizeHeight() {
  if (typeof window === 'undefined') {
    return FALLBACK_VIEWPORT_HEIGHT;
  }

  return window.innerHeight || FALLBACK_VIEWPORT_HEIGHT;
};
/**
 * Rewrites a CDN attachment URL to ask the CDN for a height-resized variant,
 * so we don't ship the full upload to the browser. No-op when the consumer
 * opted out via `displayOriginalImage`, when the URL is already sized, or
 * when the URL isn't a resizable `/attachment/` path.
 *
 * `height` is optional: pass an accurate per-element value (e.g. the IO
 * observer's `offsetHeight * 2`) when measured, otherwise the upfront
 * viewport-based default is used.
 *
 * Note on CLS: when called without a measured `height`, this falls back to
 * the current viewport height (or `FALLBACK_VIEWPORT_HEIGHT` on the server).
 * If the real device viewport differs from the fallback, the resized image's
 * intrinsic dimensions won't match what the layout reserved, causing a small
 * reflow once the image decodes.
 */


var buildResizedAttachmentSrc = function buildResizedAttachmentSrc(src, displayOriginalImage, height) {
  if (displayOriginalImage === true) return src;
  if (checkIfImageResizedAlready.test(src)) return src;
  if (!src.includes('/attachment/')) return src;
  var resolvedHeight = height !== null && height !== void 0 ? height : getDefaultResizeHeight();
  return src.replace('/attachment/', "/attachment/height/".concat(resolvedHeight, "/"));
};

var isLazyLoadingActive = function isLazyLoadingActive() {
  if (typeof document === 'undefined') {
    return false;
  }

  return _common.common.isModuleActive('lazyLoading') && (0, _globals.default)('application') !== 'control' && document.body.classList.contains('twig_site-index');
};

/**
 * Module-level singleton observer shared by every `LazyBackground` instance on
 * the page. Lazily created on first observe, then kept alive for the lifetime
 * of the document — there's no `disconnect()` call by design. Each
 * `LazyBackground` cleans up its own entry in `backgroundCallbacks` and calls
 * `observer.unobserve(target)` on unmount, so the observer's internal target
 * set is bounded by the live DOM. The observer itself is GC'd when the page
 * unloads. The `WeakMap` guarantees that callback closures don't pin
 * detached elements either.
 */
var sharedBackgroundObserver = null;
var backgroundCallbacks = new WeakMap();

var getBackgroundObserver = function getBackgroundObserver() {
  if (typeof window === 'undefined' || !('IntersectionObserver' in window)) {
    return null;
  }

  if (sharedBackgroundObserver === null) {
    sharedBackgroundObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var _sharedBackgroundObse;

        if (!entry.isIntersecting) {
          return;
        }

        var target = entry.target;
        var callback = backgroundCallbacks.get(target);

        if (callback === undefined) {
          return;
        }

        backgroundCallbacks.delete(target);
        (_sharedBackgroundObse = sharedBackgroundObserver) === null || _sharedBackgroundObse === void 0 ? void 0 : _sharedBackgroundObse.unobserve(target);
        callback(target);
      });
    });
  }

  return sharedBackgroundObserver;
};

var observeLazyBackground = function observeLazyBackground(target, callback) {
  var observer = getBackgroundObserver();

  if (observer === null) {
    return false;
  }

  backgroundCallbacks.set(target, callback);
  observer.observe(target);
  return true;
};

var unobserveLazyBackground = function unobserveLazyBackground(target) {
  var _sharedBackgroundObse2;

  backgroundCallbacks.delete(target);
  (_sharedBackgroundObse2 = sharedBackgroundObserver) === null || _sharedBackgroundObse2 === void 0 ? void 0 : _sharedBackgroundObse2.unobserve(target);
};

var resolveImageA11y = function resolveImageA11y(alt, title) {
  var description = alt || title;
  return {
    description: description,
    role: description !== '' ? 'img' : 'presentation'
  };
};

var LazyImg = function LazyImg(_ref) {
  var className = _ref.className,
      src = _ref.src,
      srcSet = _ref.srcSet,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? '' : _ref$alt,
      displayOriginalImage = _ref.displayOriginalImage;

  var _resolveImageA11y = resolveImageA11y(alt, title),
      description = _resolveImageA11y.description,
      role = _resolveImageA11y.role;

  var isLazy = isLazyLoadingActive();
  var resolvedSrc = buildResizedAttachmentSrc(src, displayOriginalImage);
  return (0, _preact.h)("img", {
    role: role,
    className: className,
    src: (0, _absoluteUrlRuntime.resolveUrl)(resolvedSrc),
    srcSet: srcSet,
    style: style,
    title: title,
    alt: description,
    loading: isLazy ? 'lazy' : 'eager',
    decoding: "async"
  });
};

var LazyBackground = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(LazyBackground, _Component);

  var _super = _createSuper(LazyBackground);

  function LazyBackground() {
    var _this;

    (0, _classCallCheck2.default)(this, LazyBackground);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      resolvedSrc: null
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "ref", null);
    return _this;
  }

  (0, _createClass2.default)(LazyBackground, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (!isLazyLoadingActive() || this.ref === null) {
        this.setState({
          resolvedSrc: buildResizedAttachmentSrc(this.props.src, this.props.displayOriginalImage)
        });
        return;
      }

      var target = this.ref;
      var observed = observeLazyBackground(target, function (element) {
        var componentHeight = element.offsetHeight ? element.offsetHeight * 2 : window.innerHeight;
        var newSrc = buildResizedAttachmentSrc(_this2.props.src, _this2.props.displayOriginalImage, componentHeight);
        element.classList.remove('lazy');

        _this2.setState({
          resolvedSrc: newSrc
        });
      });

      if (!observed) {
        this.setState({
          resolvedSrc: buildResizedAttachmentSrc(this.props.src, this.props.displayOriginalImage)
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.ref !== null) {
        unobserveLazyBackground(this.ref);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          children = _this$props.children,
          _this$props$style = _this$props.style,
          style = _this$props$style === void 0 ? {} : _this$props$style,
          src = _this$props.src,
          _this$props$title = _this$props.title,
          title = _this$props$title === void 0 ? '' : _this$props$title,
          _this$props$alt = _this$props.alt,
          alt = _this$props$alt === void 0 ? '' : _this$props$alt,
          className = _this$props.className;
      var resolvedSrc = this.state.resolvedSrc;

      var _resolveImageA11y2 = resolveImageA11y(alt, title),
          description = _resolveImageA11y2.description,
          role = _resolveImageA11y2.role;

      var isBrowser = typeof window !== 'undefined';

      if (resolvedSrc !== null) {
        return (0, _preact.h)("div", {
          role: role,
          "aria-label": description,
          className: className,
          style: _objectSpread(_objectSpread({}, style), {}, {
            backgroundImage: "url(".concat(resolvedSrc, ")")
          }),
          title: title
        }, children);
      }

      return (0, _preact.h)("div", {
        role: role,
        "aria-label": description,
        ref: function ref(_ref2) {
          _this3.ref = _ref2;
        },
        className: (0, _classnames.default)('lazy', className),
        "data-src": src,
        style: isBrowser ? style : _objectSpread(_objectSpread({}, style), {}, {
          backgroundImage: "url(".concat(src, ")")
        }),
        title: title
      }, children);
    }
  }]);
  return LazyBackground;
}(_preact.Component);

var LazyImage = function LazyImage(props) {
  if (props.type === 'img') {
    return (0, _preact.h)(LazyImg, props);
  }

  return (0, _preact.h)(LazyBackground, props);
};

var _default = LazyImage;
exports.default = _default;